import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setJWTToken } from '../utils/jwtUtil'
import { sendTypedMessage } from '../utils/iframeUtil'

function useIframeMessageHandler() {
  const dispatch = useDispatch()

  const liveReportRegex = /^\/cb\/web\/live-report(\/.*)?$/
  const isLiveReport = liveReportRegex.test(window.location.pathname)

  useEffect(() => {
    if (isLiveReport) return
    const handleMessage = (e: MessageEvent) => {
      switch (e.data.type) {
        case 'JWT':
          setJWTToken(e.data.data)
          break
        // case "SEARCH_INFO":
        //   dispatch(updateSearchInfo(e.data.data));
        //   break;
        default:
          // do nothing for unknown message type
          break
      }
    }
    window.addEventListener('message', handleMessage, false)
    // send request to core since react side is ready to receive message.
    // same thing is done in api.js to prevent any kind of timing issue.
    sendTypedMessage('RequestSearchInfo', '')
    sendTypedMessage('RequestJWTToken', '')
    // eslint-disable-next-line consistent-return
    return function cleanup() {
      if (isLiveReport) return
      window.removeEventListener('message', handleMessage, false)
    }
  }, [dispatch, isLiveReport])
}
export default useIframeMessageHandler
